export default function DogParksSection() {
  return (
    <section className="bg-[#F5F1EB] py-20 px-6 lg:px-14">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
          <div className="rounded-2xl overflow-hidden h-[360px]">
            <img
              src="https://public.readdy.ai/ai/img_res/d182bae45cf0f5e3fccb72a6bcf15c81.jpg"
              alt="Highlands NC dog park off-leash area for visiting dogs"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div>
            <p className="text-[#C9A96E] text-xs tracking-[0.3em] uppercase font-jost mb-4">/ Off-Leash Space</p>
            <h2 className="font-cormorant text-5xl text-[#1A1A18] font-light mb-6">
              Dog Parks in<br /><em className="italic">Highlands NC</em>
            </h2>

            <article className="bg-white rounded-2xl p-8">
              <div className="flex items-start gap-4 mb-4">
                <div className="w-11 h-11 flex items-center justify-center rounded-full bg-[#EDE8E0] shrink-0">
                  <i className="ri-map-pin-2-line text-[#2D4A3E] text-xl" />
                </div>
                <div>
                  <h3 className="font-cormorant text-2xl text-[#1A1A18] font-medium mb-1">Highlands Dog Park</h3>
                  <span className="text-[#6B8C7D] text-xs font-jost bg-[#EEF5EE] px-3 py-1 rounded-full">Highlands, NC</span>
                </div>
              </div>
              <p className="text-[#5C5850] font-jost text-sm leading-relaxed">
                A well-maintained, fenced dog park giving dogs a safe and comfortable space to run off-leash and socialize. A convenient stop for guests staying in the area who want to give their dogs some open space to stretch out and play.
              </p>
              <div className="mt-5 flex flex-wrap gap-3">
                <span className="flex items-center gap-1.5 text-xs font-jost text-[#5C5850] bg-[#EDE8E0] px-3 py-1.5 rounded-full">
                  <div className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-shield-check-line text-[#2D4A3E] text-xs" />
                  </div>
                  Fully fenced
                </span>
                <span className="flex items-center gap-1.5 text-xs font-jost text-[#5C5850] bg-[#EDE8E0] px-3 py-1.5 rounded-full">
                  <div className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-sun-line text-[#C9A96E] text-xs" />
                  </div>
                  Open daily
                </span>
                <span className="flex items-center gap-1.5 text-xs font-jost text-[#5C5850] bg-[#EDE8E0] px-3 py-1.5 rounded-full">
                  <div className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-paw-print-line text-[#2D4A3E] text-xs" />
                  </div>
                  Off-leash area
                </span>
              </div>
            </article>
          </div>
        </div>
      </div>
    </section>
  );
}
